<template>
    <div class="card border border-0 mb-3  job-item bg_active">
        
        <div class="card-body">
            <div class="row align-items-center">
                <div class="col-8 time_line" @click="jobClick(job.id)">
                    <div class="h5 mb-1 cartype">{{ job.cartypename }}</div>
                    <div class="time_line_item d-flex align-items-center mb-0">
                        <span><img src="../assets/img/icon/start.svg" alt="" class="pin"></span>
                        <span class="position">{{ job.position_call_name }}</span>
                    </div>
                    <div class="line_time_line"></div>
                    <div class="time_line_item d-flex align-items-center mb-0">
                        <span><img src="../assets/img/icon/end.svg" alt="" class="pin"></span>
                        <span class="position">{{ job.position_send_name }}</span>
                    </div>
                </div>
                <div class="col-4 get_job">
                    <div class="text-center time_call"><span class="pi pi-clock"></span>  {{ job.time_call_time }}</div>
                    <div v-if="job.status_id == 1">
                        <button  class="btn btn-primary btn-rouned w-100"  @click="jobClick(job.id)">รับงาน</button>
                    </div>
                    <div v-else-if="job.status_id == 2" class="text-center ">
                        <div v-if="job.officer_id == officer_id">
                            <button class="btn btn-warning btn-rouned  w-100 " @click="getJob(job.id,'3')">เสร็จ</button>
                        </div>
                        <div v-else @click="jobClick(job.id)">
                            <span class="text-dark">{{ job.statusname }}</span>
                        </div>
                    </div>
                    <div v-else-if="job.status_id == 3" class="text-center text-success">
                        <div v-if="job.officer_id == officer_id">
                            เสร็จสิ้น
                        </div>
                        <div v-else>0</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex align-items-center justify-content-between">
            <div><span v-if="job.remark != null && job.remark != ''" ><span class="pi pi-info-circle"></span> {{ job.remark }}</span></div>
            <div v-if="job.officername != null" class="text-end">
                {{ job.officername }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'JobItem',
  props: {
        job: {
            type: Object,
            required: true
        }
  },
    data () {
        return {
            officer_id : localStorage.getItem('officer_id')
        }
    },
    methods: {
        jobClick(id) {
            // ส่ง event ชื่อ 'custom-click' ไปยัง parent component
            this.$emit('job-click',id);
        },
        getJob(job_id,status_id){
            let data= {job_id:job_id,status_id:status_id}
            this.$emit('get-job',data);
        }
    }
  
}
</script>


<style scoped>
.position{
    font-size: 1.1rem;
}
.cartype{
    font-size: 1.1rem;
    font-weight: 600;
}
.pin{
    width: 18px;
    height: 18px;
    margin-right: 10px;
}
.line_time_line{
    border-left: 2px solid #b8b8b8;
    height: 19px;
    margin-left: 8px;
    margin-right: 9px;
    margin-bottom: -6px;
    margin-top: -8px;
}
.remark{
    margin-top: 5px;
    background-color: #f3f3f3;
    padding: 2px 5px;
    border-radius: 5px;
    font-size: 0.85rem;
}
.time_call{
    font-size: 0.85rem;
    font-weight: 500;
    color: #686868;
    margin-bottom: 5px;
}
.card{
    /* box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px !important; */
    box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px !important;
}
.card-footer{
    font-size: 0.8rem;
    background-color: #e9e9e9;
    color: #000;
    border-radius:  0 0 0.6rem 0.6rem !important;
    border : none !important;
}
.btn-rouned{
    border-radius: 0.4rem !important;
}
</style>
